import React, { useEffect } from "react";
import { createBrowserHistory } from "history";
import { Redirect, Route, Router, Switch } from "react-router-dom";
import Notfound from "./views/notfound/NotFound";
import Index from "./views/Index";
import Career from "./views/Career/Career";
import CheckUserInfo from "./views/CheckUserInfo/CheckUserInfo";
import Otp from "./views/Otp/Otp";
import Questions from "./views/Questions/Questions";
// import Preregis from "./views/Preregis/Preregis";
import SnapIdcard from "./views/SnapIdcard/SnapIdcard";
import TermAndCon from "./views/TermAndCon/TermAndCon";
import Pdpa from "./views/Pdpa/Pdpa";
import Suit from "./views/Suit/Suit";
import Suit10 from "./views/Suit/Suit10";
import Suit12 from "./views/Suit/Suit12";
import Suit15 from "./views/Suit/Suit15";
import SuitResult from "./views/Suit/SuitResult";
import InvestInfoIncome from "./views/InvestInfo/InvestInfoIncome";
import InvestInfoPurpose from "./views/InvestInfo/InvestInfoPurpose";
import InvestInfoAsset from "./views/InvestInfo/InvestInfoAsset";
import FamilyStatusChild from "./views/FamilyStatusChild/FamilyStatusChild";
import IdcForm from "./views/IdcForm/IdcForm";
import IdcAddress from "./views/Address/IdcAddress";
import ProductsChoice from "./views/ProductsChoice/ProductsChoice";
import ExampleSign from "./views/Sign/ExampleSign";
import AttachSign from "./views/Sign/AttachSign";
import Married from "./views/Status/Married";
import AtsList from "./views/Ats/AtsList";
import AtsApply from "./views/Ats/AtsApply";
import AtsWaiting from "./views/Ats/AtsWaiting";
import CurrentAddress from "./views/Address/CurrentAddress";
import WorkplaceAddress from "./views/Address/WorkplaceAddress";
import NdidInformation from "./views/Ndid/NdidInformation";
import NdidCondition from "./views/Ndid/NdidCondition";
import NdidList from "./views/Ndid/NdidList";
import NdidWaiting from "./views/Ndid/NdidWaiting";
import Summary from "./views/Summary/Summary";
import TcAndCon from "./views/TcAndCon/TcAndCon";
import FIFConsent from "./views/FIFConsent/FIFConsent";
import ProductsConsent from "./views/ProductsConsent/ProductsConsent";
import crsBirthAddress from "./views/CRS/crsBirthAddress";
import crsForm from "./views/CRS/crsForm";
import CRSDeclareLocation from "./views/CRS/crsDeclareLocation";
import CRSConsentPage from "./views/CRS/crsConsent";
import IslamCon from "./views/IslamCon/IslamCon";
import DipchipWaiting from "./views/EKYC/DipchipWaiting";
import ThaiDWaiting from "./views/EKYC/ThaiDWaiting";
import EkycList from "./views/EKYC/EkycList";
import ThaiDCondition from "./views/EKYC/ThaiDCondition";
import HouseRegistration from "./views/HouseRegistration/HouseRegistration";
import DigitalConsent from "./views/DigitalConsent/DigitalConsent";
import BrowserDetection from "./components/BrowserDetection";

const hist = createBrowserHistory();

function Routes() {
  useEffect(() => {
    const splashScreen = document.querySelector(".app-splash-screen");
    if (splashScreen) {
      splashScreen.style.opacity = 0;
      setTimeout(() => {
        splashScreen && splashScreen.parentNode.removeChild(splashScreen);
      }, 500);
    }
  }, []);
  return (
    <Router history={hist}>
      <BrowserDetection>
        <Switch>
          <Redirect exact from="/" to="/index.html" />
          <Route path="/index.html" component={Index} />
          <Route path="/career" component={Career} />
          <Route path="/checkuserinfo" component={CheckUserInfo} />
          <Route path="/snapidcard" component={SnapIdcard} />
          <Route path="/IdcForm" component={IdcForm} />
          <Route path="/house_registration" component={HouseRegistration} />
          <Route path="/termandcon" component={TermAndCon} />
          <Route path="/pdpa" component={Pdpa} />
          <Route path="/otp" component={Otp} />
          <Route path="/questions" component={Questions} />
          <Route path="/suit" component={Suit} />
          <Route path="/suit_10" component={Suit10} />
          <Route path="/suit_12" component={Suit12} />
          <Route path="/suit_15" component={Suit15} />
          <Route path="/suit_result" component={SuitResult} />
          <Route path="/invest_info_income" component={InvestInfoIncome} />
          <Route path="/invest_info_purpose" component={InvestInfoPurpose} />
          <Route path="/invest_info_asset" component={InvestInfoAsset} />
          <Route path="/familystatuschild" component={FamilyStatusChild} />
          <Route path="/address" component={IdcAddress} />
          <Route path="/current_address" component={CurrentAddress} />
          <Route path="/workplace_address" component={WorkplaceAddress} />
          <Route path="/products_choice" component={ProductsChoice} />
          <Route path="/products_consent" component={ProductsConsent} />
          <Route path="/example_sign" component={ExampleSign} />
          <Route path="/attach_sign" component={AttachSign} />
          <Route path="/status" component={Married} />
          <Route path="/ats_list" component={AtsList} />
          <Route path="/ats_apply" component={AtsApply} />
          <Route path="/ats_waiting" component={AtsWaiting} />
          <Route path="/ndid_information" component={NdidInformation} />
          <Route path="/ndid_condition" component={NdidCondition} />
          <Route path="/ndid_list" component={NdidList} />
          <Route path="/ndid_waiting" component={NdidWaiting} />
          <Route path="/summary" component={Summary} />
          <Route path="/tc_confirm" component={TcAndCon} />
          <Route path="/fif_consent" component={FIFConsent} />
          <Route path="/gtoken_consent" component={DigitalConsent} />
          <Route path="/birth_address" component={crsBirthAddress} />
          <Route path="/crs_form" component={crsForm} />
          <Route path="/declare_location" component={CRSDeclareLocation} />
          <Route path="/crs_consent" component={CRSConsentPage} />
          <Route path="/ekyc" component={EkycList} />
          <Route path="/dipchip_waiting" component={DipchipWaiting} />
          <Route path="/thaid_waiting" component={ThaiDWaiting} />
          <Route path="/thaid_condition" component={ThaiDCondition} />
          <Route path="/islam_condition" component={IslamCon} />
          <Route component={Notfound} />
        </Switch>
      </BrowserDetection>
    </Router>
  );
}

export default Routes;
